import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {PipesModule} from '../../../pipes/pipes.module';
import {ReopenHeadConfirmComponent} from './reopen-head-confirm.component';

@NgModule({
    declarations: [ReopenHeadConfirmComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        PipesModule,
    ],
    exports: [ReopenHeadConfirmComponent],
})
export class ReopenHeadConfirmModule {
}
